export enum WorkflowType {
  videocontent = 'videocontent',
  musiccontent = 'musiccontent',
  appscanvas = 'appscanvas',
  copy = 'copyworkflow'
}
